module.exports = __webpack_public_path__ + "img/creditline.e3d20e14.png";